<template>
    <div class="form-body without-side">
        <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
        <div class="img-holder">
            <div class="info-holder">
                <img src="../../assets/images/graphic3.svg" alt="">
            </div>
        </div>
        <div class="form-holder mt-5">
            <div class="form-content">
                <div class="form-items shadow">
                    <div class="website-logo">
                        <router-link to="/">
                            <div class="logo">
                                <img class="logo-size" v-bind:src="imageLogoPath + data.slider_background" alt="">
                            </div>
                        </router-link>
                    </div>
                    <h3>Register new account</h3>
                    <form @submit.prevent="signup">
                        <input class="form-control" type="text" name="name" v-model="name" placeholder="Full Name" required>
                        <input class="form-control" type="text" name="email" v-model="email" placeholder="E-mail Address" required>
                        <input class="form-control" type="password" name="password" v-model="password" placeholder="Password" required>
                        <input class="form-control" type="password" name="password_confirmation" v-model="password_confirmation" placeholder="Confirm Password" required>
                        <div class="form-button mt-3">
                            <button id="submit" type="submit" class="ibtn">Register</button>
                        </div>
                    </form>
                    <div class="other-links">
                        <div class="text">Or</div>
                        <a href="#"><i class="fab fa-facebook-f"></i>Facebook</a><a href="#"><i class="fab fa-google"></i>Google</a>
                    </div>
                    <div class="page-links">
                        <router-link to="/login">Login to account</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "SignupPage",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            name: null,
            email: null,
            password: null,
            password_confirmation: null,
            data: [],
            imagePath: this.$api + "upload/header_logo/",
            imageLogoPath: this.$api + "upload/slider_background/"
        }
    },
    created(){
        this.getHeaderData();
    },
    methods: {
        getHeaderData: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/geek-site"
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.data = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        signup: function() {
            this.isLoading = true
            if(!this.name || !this.email || !this.password || !this.password_confirmation) {
                this.isLoading = false
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter name, email and password!"
                });
            }
            else if(this.password != this.password_confirmation) {
                this.isLoading = false
                this.$swal.fire({
                    icon: "error",
                    text: "Password and confirm password don't match!"
                });
            }
            else {
                this.$axios.post(this.$api + "api/geek-buyback-register", {
                    name: this.name,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation
                }).then((response) => {
                    console.log(response)
                    if(response.status == 200) {
                        this.isLoading = false
                        this.$swal.fire({
                            icon: "success",
                            text: "Successfully registered!, Please check your email for account verification."
                        });
                        this.$router.push("/login");
                    }
                    else {
                        this.isLoading = false
                        this.$swal.fire({
                            icon: "error",
                            text: "Failed! please try again."
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    this.isLoading = false
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                })
            }
        }
    }
}
</script>
<style scoped>
.form-body {
    background-color: #0093FF;
    position: relative;
    min-height: 133vh;
    font-family: myRegularFont;
    text-align: center;
    margin: 4rem 0 0;
}
</style>
